<template>
  <div class="container-list">
    <!-- <ul class="tab-wrap" >
      <li
        :class="`tab-btn ${nowIndex == index && 'active'}`"
        @click="changeTab(index,tab)"
        v-for="(tab, index) in tabList"
      >
        {{tab.name }}
      </li>
    </ul> -->
    <div class="flex">
      <div
        style="width: 20%"
        v-show="!($store.state.user.userInfo.natureId == 2)"
      >
        <unitList
          @select="getUnit"
          @getFirst="getOne"
          style="margin-top: 20px"
        ></unitList>
      </div>
      <div class="flex1">
        <div
          class="common-page common-head flex flex1"
          style="margin: 0; justify-content: space-between"
        >
          <div class="common-page common-head-title">
            <i class="icon-tr--detailed" style="padding-right: 5px"></i>
            巡查点管理
          </div>
          <!-- <div class="flex" v-show="tabList[nowIndex].id == 0">
            <div
              class="ml20"
              v-hasPermi="['safe:safeplaceList:query']"
              @click="showDia = true"
            >
              <el-button icon="el-icon-search" type="primary">查询</el-button>
            </div>
            <router-link
              v-hasPermi="['safe:safeplaceList:add']"
              class="ml20"
              :to="{
                path: '/wenlv/inspectionAddpoint',
                query: { areaId: params.c_point_area_id || '', cnum: cpNum },
              }"
            >
              <el-button icon="el-icon-plus" type="primary">新增</el-button>
            </router-link>
          </div> v-show="tabList[nowIndex].id == 1" -->
          <div class="flex">
            <div class="mr20" @click="showPointDilog">
              <!-- v-hasPermi="['safe:safeplaceList:query']" -->
              <el-button type="primary" v-hasPermi="['relic:relicInspectionPoint:mapList']">点位地图</el-button>
            </div>
            <div class="">
              <el-button @click="cancle" type="primary">重置</el-button>
            </div>

            <div class="ml20" @click="searchDate">
              <!-- v-hasPermi="['safe:safeplaceList:query']" -->
              <el-button icon="el-icon-search" type="primary">查询</el-button>
            </div>
            <!-- v-hasPermi="['wenwu:safeplaceList:add']" -->
            <router-link
              v-hasPermi="['relic:relicInspectionPoint:addAndUpdate']"
              class="ml20"
              :to="{
                path: '/wenlv/inspectionAddpoint',
                query: { areaId: params1.areaId || '', cnum: cpNum },
              }"
            >
              <el-button icon="el-icon-plus" type="primary" v-if="newFlag"
                >新增</el-button
              >
            </router-link>
          </div>

          <!-- <div class="common-page common-head-end">
                <i class="icon-tr-sign-out"></i>
      </div>-->
        </div>
        <div class="common-page common-body">
          <div
            class="common-page common-tool-bar"
            style="justify-content: flex-end"
          ></div>
          <div class="flex">
            <!-- <div class="choose" v-if="tabList[nowIndex].id == 0">
              <div
                class="mt10"
                style="
                  border-bottom: 1px solid #ccc;
                  padding-bottom: 10px;
                  font-weight: 900;
                "
              >
                巡查区域列表
              </div>
              <div style="height: 90%; overflow: auto">
                <div
                  class="areaitem"
                  v-for="item in areaList"
                  :class="
                    params.c_point_area_id === item.x_company_id ? 'mark' : ''
                  "
                  @click="chooseArea(item)"
                >
                  {{ item.x_company_area }}
                </div>
              </div>
            </div>  v-else-->

            <div class="choose">
              <div
                class="mt10"
                style="
                  border-bottom: 1px solid #ccc;
                  padding-bottom: 10px;
                  font-weight: 900;
                "
              >
                巡查区域列表
              </div>
              <div style="height: 90%; overflow: auto">
                <div
                  class="areaitem"
                  v-for="item in areaList"
                  :class="params1.areaId === item.areaId ? 'mark' : ''"
                  @click="chooseArea(item)"
                >
                  {{ item.areaName }}
                </div>
              </div>
            </div>

            <!-- <div class="flex1" v-if="tabList[nowIndex].id == 0">
              <div class="common-page common-list" style="margin: 0">
                <el-table :data="list" class="">
                  <el-table-column
                    prop="c_point_number"
                    label="巡查点编号"
                    align="center"
                  ></el-table-column>
                  <el-table-column
                    prop="c_point_addr"
                    align="center"
                    label="巡查点位置"
                  ></el-table-column>
                  <el-table-column
                    prop="c_point_area"
                    align="center"
                    label="巡查区域"
                  ></el-table-column>


                  <el-table-column
                    prop="c_create_time"
                    align="center"
                    label="创建时间"
                  ></el-table-column>

                  <el-table-column prop="c_states" align="center" label="状态">
                    <template slot-scope="scope">
                      {{ $map.safeState[scope.row.c_states] }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    align="center"
                    width="200px"
                    fixed="right"
                  >
                    <template slot-scope="scope">
                      <router-link
                        :to="{
                          path: '/wenlv/inspectionAddpoint',
                          query: {
                            id: scope.row.c_point_uuid,
                            cnum: cpNum,
                            areaId: params.c_point_area_id || '',
                          },
                        }"
                        v-hasPermi="['safe:safeplaceList:edit']"
                      >
                        <el-button size="mini" type="warning">编辑</el-button>
                      </router-link>
                      <el-popconfirm
                        v-if="scope.row.c_states == 1"
                        title="确定禁用单位记录吗？"
                        class="cursor"
                        v-hasPermi="['safe:safeplaceList:stop']"
                        @onConfirm="changeStatus(scope.row, 0)"
                        @confirm="changeStatus(scope.row, 0)"
                      >
                        <a slot="reference" class="red"
                          ><el-button size="mini" type="danger" plain
                            >停用</el-button
                          ></a
                        >
                      </el-popconfirm>
                      <el-popconfirm
                        v-if="scope.row.c_states == 0"
                        title="确定启用此单位吗？"
                        class="cursor"
                        v-hasPermi="['safe:safeplaceList:stop']"
                        @onConfirm="changeStatus(scope.row, 1)"
                        @confirm="changeStatus(scope.row, 1)"
                      >
                        <a slot="reference"
                          ><el-button type="primary" size="mini"
                            >开启</el-button
                          ></a
                        >
                      </el-popconfirm>

                      <el-popconfirm
                        title="确定删除此单位吗？"
                        class="cursor"
                        @onConfirm="changeStatus(scope.row, 2)"
                        @confirm="changeStatus(scope.row, 2)"
                        v-hasPermi="['safe:safeplaceList:remove']"
                      >
                        <a slot="reference"
                          ><el-button type="danger" size="mini"
                            >删除</el-button
                          ></a
                        >
                      </el-popconfirm>
                      <el-button
                        type="info"
                        icon="el-icon-view"
                        size="mini"
                        plain
                        @click="makeerwei(scope.row)"
                      ></el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <el-pagination
                background
                layout="prev, pager, next"
                @current-change="pageChange"
                :page-size="10"
                :total="total"
              ></el-pagination>
            </div> v-else-->
            <div class="flex1">
              <div class="common-page common-list" style="margin: 0">
                <el-table :data="list1" class="mt10">
                  <el-table-column
                    prop="pointName"
                    label="巡查点名称"
                    align="center"
                  ></el-table-column>
                  <!-- <el-table-column
                prop="c_point_name"
                label="巡查点名称"
                align="center"
              ></el-table-column> -->
                  <el-table-column
                    prop="pointAddr"
                    align="center"
                    label="巡查点位置"
                  ></el-table-column>
                  <el-table-column
                    prop="areaName"
                    align="center"
                    label="巡查区域"
                  ></el-table-column>
                  <!-- <el-table-column
            prop="m_rate"
            align="center"
            label="巡查频次"
          ></el-table-column> -->

                  <el-table-column
                    prop="createTime"
                    align="center"
                    label="创建时间"
                  ></el-table-column>

                  <el-table-column prop="status" align="center" label="状态">
                    <template slot-scope="scope">
                      {{ $map.safeState[scope.row.status] }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    align="center"
                    width="200px"
                    fixed="right"
                  >
                    <template slot-scope="scope">
                      <router-link
                        :to="{
                          path: '/wenlv/inspectionAddpoint',
                          query: {
                            id: scope.row.id,
                            cnum: scope.row.companyNum,
                          },
                        }"
                        v-hasPermi="['relic:relicInspectionPoint:addAndUpdate']"
                      >
                        <!-- v-hasPermi="['wenwu:safeplaceList:edit']"  cpNum-->
                        <el-button size="mini" type="warning" plain
                          >编辑</el-button
                        >
                      </router-link>
                      <!-- v-hasPermi="['wenwu:safeplaceList:stop']" -->
                      <el-popconfirm
                        v-if="scope.row.status == 1"
                        title="确定禁用单位记录吗？"
                        class="cursor"
                        @onConfirm="changeStatus1(scope.row, 0)"
                        @confirm="changeStatus1(scope.row, 0)"
                      >
                        <a slot="reference" class="red"
                          ><el-button
                            size="mini"
                            type="danger"
                            plain
                            v-hasPermi="[
                              'relic:relicInspectionPoint:updateStatus',
                            ]"
                            >停用</el-button
                          ></a
                        >
                      </el-popconfirm>
                      <!-- v-hasPermi="['wenwu:safeplaceList:stop']" -->
                      <el-popconfirm
                        title="确定启用此单位吗？"
                        v-if="scope.row.status == 0"
                        class="cursor"
                        @onConfirm="changeStatus1(scope.row, 1)"
                        @confirm="changeStatus1(scope.row, 1)"
                      >
                        <a slot="reference"
                          ><el-button
                            type="primary"
                            size="mini"
                            plain
                            v-hasPermi="[
                              'relic:relicInspectionPoint:updateStatus',
                            ]"
                            >开启</el-button
                          ></a
                        >
                      </el-popconfirm>

                      <el-popconfirm
                        title="确定删除此单位吗？"
                        class="cursor"
                        @onConfirm="changeStatus1(scope.row, 2)"
                        @confirm="changeStatus1(scope.row, 2)"
                      >
                        <!--  -->
                        <a slot="reference"
                          ><el-button
                            type="danger"
                            size="mini"
                            v-hasPermi="['relic:relicInspectionPoint:remove']"
                            >删除</el-button
                          ></a
                        >
                      </el-popconfirm>
                      <el-button
                        type="info"
                        icon="el-icon-view"
                        size="mini"
                        plain
                        @click="makeerwei(scope.row)"
                      ></el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <!-- <el-pagination background layout="prev, pager, next" @current-change="pageChange" :page-size="10" :total="total1"></el-pagination> :page-sizes="10"-->
              <el-pagination
                class="pagination"
                background
                layout="prev, pager, next"
                :current-page.sync="params1.pageNum"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-size.sync="params1.pageSize"
                :total="total1"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="查询"
      :visible.sync="showDia"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="100px">
        <el-form-item label="巡查点名称">
          <el-input v-model="form.pointName"></el-input>
          <!-- <el-select v-model="form.pointNum" placeholder="请选择巡查点编号">
            <el-option
              v-for="item in list1"
              :label="item.pointNum"
              :value="item.pointNum"
            ></el-option>
          </el-select> -->
        </el-form-item>
        <el-form-item label="巡查点位置" prop="desc">
          <el-input v-model="form.pointAddr"></el-input>
        </el-form-item>
      </el-form>
      <!-- <fm-generate-form
        :data="searchForm"
        :remote="remoteFuncs"
        :value="editData"
        ref="searchForm"
      ></fm-generate-form> -->
      <div class="center">
        <el-button type="primary" @click="searchSubmit('form')" size="small"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="showDia1"
      width="50%"
      :close-on-click-modal="false"
    >
      <div
        ref="imageWrapper"
        id="imageWrapper"
        class="flex1"
        style="padding: 10px 20px 20px"
      >
        <div
          class="er_title flex1 center"
          style="
            font-size: 30px;
            font-weight: 900;
            border-bottom: 1px solid #000;
            padding: 10px 0;
          "
        >
          {{ $store.state.user.company.cName }}
        </div>
        <div class="flex mt20 center" style="padding-right: 15px">
          <el-form v-model="erform" style="min-width: 55%">
            <el-form-item prop="area" label-width="10px" label="">
              <!-- <div slot="label" style="font-size:24px">编号:</div> -->
              <div style="font-size: 22px">
                {{ "编号: " + erform.pointNum }}
              </div>
            </el-form-item>
            <el-form-item prop="area" label-width="10px">
              <!-- <div slot="label" style="font-size:24px">名称:</div> -->

              <div style="font-size: 22px">
                {{ "名称: " + erform.pointName }}
              </div>
            </el-form-item>
            <el-form-item prop="area" label-width="10px">
              <div style="font-size: 22px">
                {{ "位置: " + erform.pointAddr }}
              </div>
            </el-form-item>
          </el-form>
          <div
            class="ml10 mt20"
            style="width: 200px; height: 200px"
            id="qrcode"
            ref="qrcode"
          ></div>
        </div>
      </div>

      <div class="center">
        <el-button type="primary" @click="doPrint('imageWrapper')" size="small"
          >打印</el-button
        >
        <el-button
          type="success"
          size="small"
          @click="toImage('imageWrapper', '1')"
          >下载</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="点位地图"
      :visible.sync="showPoint"
      :close-on-click-modal="false"
      width="90%"
    >
      <div class="map-wrap">
        <!-- <div style="margin-top: 15px;">
        <el-input placeholder="请输入内容" v-model="input3" class="zong_input">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
      </div> -->
        <div id="container" style="width:100%;height:500px"></div>
        <div class="search-wrap">
          <!-- 搜索框 -->
          <div class="search">
            <el-input
              placeholder="请输入内容"
              v-model="address"
              @focus="jujiao"
              class="input-with-select"
              clearable
            >
              <!-- @input="handleSearch" -->
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="handleSearch"
              ></el-button>
            </el-input>
          </div>
          <div v-show="showResultFlag" class="search-result">
            <div
              v-for="(item, index) in searchResult"
              class="item"
              :key="index"
              @click="reverseeocoding(item)"
            >
              <div style="overflow:hidden;">
                <span class="address ellipsis">{{ item.pointName }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import unitList from "@/components/unitList1";

import { getCompanyList, switchCompany } from "../../api/company";
import html2canvas from "html2canvas";
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      showResultFlag: false,
      searchResult: [],
      address: "",
      showPoint: false,
      list: [],
      tabList: this.$store.state.user.userInfo.isWenwu
        ? [{ name: "文物巡查", id: 1 }]
        : [{ name: "消防巡查", id: 0 }],

      cpNum: "",
      nowIndex: 0,
      params: {
        page: 1,
        c_point_name: "",
        c_point_addr: "",
        c_point_number: "",
        c_point_area: "",
        c_company_num: this.$store.state.user.company.cCompanyNum || "",

        c_point_area_id: "",
      },
      list1: [],
      total1: 0,
      params1: {
        companyNum: "",
        pageNum: 1,
        areaId: "",
        pageSize: 10,
        pointAddr: "",
        pointNum: "",
      },
      imgUrl: "",
      areaList: [],
      erform: {},
      total: 0,
      showDia: false,
      showDia1: false,
      searchForm: this.$getForm("safePlace"),
      editData: {},
      newFlag: false,
      form: {
        pointNum: "",
        pointAddr: "",
      },
      remoteFuncs: {
        placeList: [], // 区域
        _this: this,
        getPlace(resolve) {
          var _this = this._this;
          _this.$post("/xuncha/selectxcname").then((res) => {
            resolve(res.data);
          });
        },
        getNumber(resolve) {
          var _this = this._this;
          _this.$post("/xuncha/selectxcnum").then((res) => {
            resolve(res.data);
          });
        },

        getUnit(resove) {
          var _this = this._this;
          _this.$post("/devicemanage/selectconpanybyme").then((res) => {
            resove(res.data);
          });
        },
      },
      totleMap: null,
      markerList: [],
      marker: null,
      jingdu: 119.97,
      weidu: 36.77,
    };
  },
  created() {},
  components: { unitList },
  methods: {
    jujiao() {
      // this.searchResult=this.markerList.filter((item,index)=>{
      //     return item
      // })
      // if (this.searchResult) {
      //   this.showResultFlag=true
      // }
    },

    reverseeocoding(val) {
      this.showResultFlag = false;
      console.log(val);
      this.markerList.forEach((item, index) => {
        item.status = 1;
      });
      if (val.gpsLat == "" || val.gpsLon == "") {
        this.$message({
          message: "暂无经纬度",
          type: "warning",
          duration: 700,
        });
      } else {
        // this.totleMap.remove(this.marker)

        this.markerList.forEach((item, index) => {
          if (item.gpsLon == val.gpsLon && item.gpsLat == val.gpsLat) {
            item.status = 0;
            this.address = item.pointName;
            this.totleMap.remove(this.marker);
            this.makeMarker();
            this.totleMap.setCenter(
              [Number(val.gpsLon), Number(val.gpsLat)],
              false,
              1500
            );
          }
        });
      }
    },
    handleSearch() {
      this.markerList.forEach((item, index) => {
        item.status = 1;
      });
      this.showResultFlag = false;

      console.log(this.address, "address");
      if (this.address) {
        this.markerList.forEach((item, index) => {
          if (item.pointName.includes(this.address)) {
            this.jingdu = Number(item.gpsLon);
            this.weidu = Number(item.gpsLat);
            item.status = 0;
          }
        });
      } else {
        this.jingdu = 119.97;
        this.weidu = 36.77;
      }
      this.totleMap.remove(this.marker);
      this.makeMarker();
      this.totleMap.setCenter([this.jingdu, this.weidu], false, 1500);
      // this.initMap()
    },
    showPointDilog() {
      this.address=''
      this.showPoint = true;
      this.$get("/relic/relicInspectionPoint/mapList", this.params1).then(
        (res) => {
          // console.log(res,3333);
          this.markerList = res.data;
          this.markerList.forEach((item, index) => {
            item.status = 1;
          });
          this.$nextTick(() => {
            this.initMap();
          });
        }
      );
    },
    initMap() {
      // let gpsLat = this.markerList[0].gpsLat;
      // let gpsLon = this.markerList[0].gpsLon;
      this.totleMap = new AMap.Map("container", {
        center: [this.jingdu, this.weidu],
        // center: [gpsLon, gpsLat],
        zoom: 10,
        resizeEnable: true,
      });
      // 添加搜索控件

      this.makeMarker();
    },
    makeMarker() {
      // console.log(this.markerList, 33333333);
      this.markerList.forEach((item, index) => {
        // console.log(item);

        //添加点标记
        let a = false;
        this.marker = new AMap.Marker({
          position: [Number(item.gpsLon), Number(item.gpsLat)],
          offset: new AMap.Pixel(-1, -3),
          icon:new AMap.Icon({
            image:item.status == 0
              ? require("../../assets/img/redgps.png")
              : require("../../assets/img/greengps.png"),
              size:new AMap.Size(20,20),
              imageSize:new AMap.Size(20,20),
          })
            // item.status == 0
            //   ? require("../../assets/img/redgps.png")
            //   : require("../../assets/img/greengps.png"),
          // label: {
          //   content: item.pointName,
          //   offset: new AMap.Pixel(30, 0),
          // },
        });
        var label = new AMap.Marker({
          position: [Number(item.gpsLon), Number(item.gpsLat)],
          // 标注位置坐标
          map: this.totleMap,
          offset: new AMap.Pixel(5, 0),
          content: `<div style="width:300px;padding: 10px 15px;">点位：${item.pointName}<div>经度：${item.gpsLon}</div><div>纬度：${item.gpsLat}</div> </div>`, // 标注内容
        });
        label.hide();
        this.marker.on("mouseover", function() {
          // console.log(index);
          // console.log('鼠标悬浮到点了');
          label.show();
        }); // 监听鼠标移出事件
        this.marker.on("mouseout", function() {
          // console.log('鼠标移出点了');
          label.hide();
        });

        this.totleMap.add(this.marker);
      });
    },
    handleSizeChange(val) {
      this.params1.pageSize = val; //更新每页的条数
      this.getList(); //重新获取列表数据
      this.getWWList();
    },
    handleCurrentChange(val) {
      this.params1.pageNum = val; //重新获取列表数据
      this.getList();
      this.getWWList();
    },
    changeTab(index, it) {
      this.nowIndex = index;
      this.getDatas();
    },
    chooseArea(it) {
      this.params1.pageNum = 1;
      // console.log(this.params1.pageNum, '页数');
      // console.log(it);
      // if (this.tabList[this.nowIndex].id == 0) {
      //   this.params.c_point_area_id = it.x_company_id;
      //   this.params.page = 1;
      //   this.getList();
      // } else {
      this.params1.areaId = it.areaId;
      this.params.page = 1;
      this.getWWList();
      // }
    },
    changeStatus(it, status) {
      console.log(status);
      var form = { c_point_uuid: it.c_point_uuid };
      var url = "";
      if (status == 1) {
        //启用
        url = "/patrol/patrolstop";
        form.c_states = 1;
      } else if (status == 2) {
        //删除
        url = "/patrol/patroldel";
      } else if (status == 0) {
        //停用
        url = "/patrol/patrolstop";
        form.c_states = 0;
      }
      console.log(form);
      console.log(url);
      this.$post(url, form).then((res) => {
        this.$message({
          message: "操作成功",
          type: "success",
          duration: 700,
        });
        this.getList();
      });
      // var c_company_num = it.c_company_num;
    },

    changeStatus1(it, status) {
      console.log(it, status);
      var form = { id: it.id };
      var url = "";
      if (status == 1) {
        //启用
        url = "/relic/relicInspectionPoint/updateStatus";
        form.status = 1;
        this.$put(url, form).then((res) => {
          this.$message({
            message: res.msg,
            type: "success",
            duration: 700,
          });
          this.getWWList();
        });
      } else if (status == 2) {
        //删除
        url = `/relic/relicInspectionPoint/${it.id}`;
        this.$remove(url).then((res) => {
          this.$message({
            message: "删除成功",
            type: "success",
            duration: 700,
          });
          this.getWWList();
        });
      } else if (status == 0) {
        //停用
        url = "/relic/relicInspectionPoint/updateStatus";
        form.status = 0;

        this.$put(url, form).then((res) => {
          this.$message({
            message: res.msg,
            type: "success",
            duration: 700,
          });
          this.getWWList();
        });
      }
      // console.log(form);
      // console.log(url);

      // var c_company_num = it.c_company_num;
    },
    searchDate() {
      this.form = {
        pointNum: "",
        pointAddr: "",
      };
      this.showDia = true;
    },
    cancle() {
      this.resetSearch();
      this.getWWList();
      this.showDia = false;
    },
    //图片格式转换方法
    dataURLToBlob(dataurl) {
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    // 图片下载
    toImage(divText, imgText) {
      let canvasID = this.$refs[divText];
      let that = this;
      let a = document.createElement("a");
      html2canvas(canvasID).then((canvas) => {
        let dom = document.body.appendChild(canvas);
        dom.style.display = "none";
        a.style.display = "none";
        document.body.removeChild(dom);
        let blob = that.dataURLToBlob(dom.toDataURL("image/png"));
        a.setAttribute("href", URL.createObjectURL(blob));
        //这块是保存图片操作  可以设置保存的图片的信息
        a.setAttribute("download", imgText + ".png");
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(blob);
        document.body.removeChild(a);
      });
    },
    // 生成二维码
    qrcode(text) {
      let qrcode = new QRCode("qrcode", {
        width: 200,
        height: 200, // 高度
        text, // 二维码内容
        render: "canvas", // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        // background: '#f0f',
        // foreground: '#ff0'
      });
    },

    //生成二维码详情modle
    makeerwei(it) {
      console.log(it);
      this.erform = it;
      this.showDia1 = true;
      setTimeout(() => {
        var obj = { key: it.c_point_number || it.pointNum, remark: it.remark };
        this.qrcode(JSON.stringify(obj));
      }, 100);
      console.log(it);
    },
    getDatas() {
      this.$get(
        "/relic/relicInspectionCompanyArea/listNotPage?companyNum=" + this.cpNum
      ).then((res) => {
        console.log(res);
        // if (res.data.length) {
        this.areaList = res.data;
        var obj = { areaId: "", areaName: "全部点位" };
        this.areaList.unshift(obj);
        this.params1.areaId = res.data[0].areaId;
        this.getWWList();
      });
      // }
    },
    getList() {
      // this.$post("/patrol/patrollist", this.params).then((res) => {
      //   this.list = res.data.list;
      //   this.total = res.data.count;
      // });
    },
    getWWList() {
      console.log(this.params1);
      this.$get("/relic/relicInspectionPoint/list", this.params1).then(
        (res) => {
          console.log(res, 22222222);
          this.list1 = res.rows;
          this.total1 = res.total;
        }
      );
    },
    pageChange(val) {
      this.params1.pageNum = 1;
      this.params1.pageSize = 10;
      this.params.page = val;
      this.getList();
    },
    searchSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.form);
          var obj = { ...this.params1, ...this.form };
          this.params1 = obj;
          this.params1.page = 1;
          this.getWWList();
          this.showDia = false;

          // alert('submit!');
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //  打印

    doPrint(divText) {
      console.log(divText);
      let subOutputRankPrint = document.getElementById(divText);
      console.log(subOutputRankPrint.innerHTML);
      let newContent = subOutputRankPrint.innerHTML;
      let oldContent = document.body.innerHTML;
      document.body.innerHTML = newContent;
      window.print();
      window.location.reload();
      document.body.innerHTML = oldContent;
      return false;
    },
    resetSearch() {
      // this.$refs.searchForm.reset();
      console.log(this.params1, 77777);
      this.params1 = {
        areaId: this.params1.areaId,
        companyNum: this.params1.companyNum,
        page: 1,
        pageNum: 1,
        pageSize: 10,
        pointName: "",
        pointNum: "",
        // c_point_number: "",
        pointAddr: "",
        // c_point_area: "",
      };
    },
    getOne(v) {
      console.log(v, 44444);
      this.cpNum = v;
      this.getDatas();
      this.newFlag = false;
      // this.getWWList()
    },
    getUnit(v) {
      this.cpNum = v;
      this.newFlag = true;
    },
  },

  watch: {
    showDia1(val) {
      console.log(val);
      if (!val) {
        document.getElementById("qrcode").innerHTML = "";
      }
    },
    address(val) {
      console.log(val);
      if (val) {
        this.searchResult = this.markerList.filter((item, index) => {
          if (item.pointName.includes(val)) {
            return item;
          }
        });
        if (this.searchResult.length>0) {
          console.log(this.searchResult,'you');
          this.showResultFlag = true;
        }else{
          console.log('meiyou');

          this.showResultFlag = true;
          this.searchResult=[{pointName:'暂无数据'}]
        }
      } else {
        this.showResultFlag = false;
        this.markerList.forEach((item, index) => {
          item.status = 1;
        });
        this.totleMap.remove(this.marker);
        this.makeMarker();
      }

      // console.log( this.searchResult,' this.searchResult');
    },
    // nowIndex(){
    //   this.list = []

    //   this.getDatas()
    // },
    cpNum() {
      this.list = [];
      this.params.c_company_num = this.cpNum;
      this.params.page = 1;
      this.params1.companyNum = this.cpNum;
      this.params1.pageNum = 1;
      this.getDatas();
    },
  },
};
</script>

<style scoped>
.el-dialog .el-dialog__body {
  padding: 0 !important;
}
.mark {
  background: #3d62de;
  color: #fff;
}
.container-list {
  height: 100%;
}
.areaitem {
  height: 30px;
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  border-bottom: 1px groove;
  margin-right: 20px;
  cursor: pointer;
}
.choose {
  border-radius: 10px;
  width: 20%;
  height: 550px;
  border: 1px solid #ccc;
}
.map-wrap {
  position: relative;
}
.search {
  width: 410px;
  margin: 16px 0 0 16px;
}
.search-result {
  width: 350px;
  margin-left: 16px;
  padding: 10px 0;
  margin-top: 5px;
  background: #fff;
  max-height: 300px;
  overflow-y: auto;
}
.search-wrap {
  position: absolute;
  top: 0;
  left: 0;
}
.texter {
  padding: 5px 10px;
  background: #fff !important;
  border: 1px solid #ccc;
  font-size: 11px;
  font-weight: 465;
  line-height: 20px;
  z-index: 99999;
  transform: translate3d(0);
}
.item {
  padding: 4px 12px;
  border-bottom: 1px solid rgb(201, 199, 199);
  cursor: pointer;
}
.address {
  line-height: 1;
  font-size: 12px;
  color: #b4b4b4;
  margin-bottom: 5px;

  /*  */
}
</style>
